export interface ListViewField {
  id?: number
  label?: string
  name?: string
  order: number
  field_type?: ViewsFieldsProps
}

export enum FilterOperatorType {
  EQUAL = 'equal',
  LT = 'lt',
  LTE = 'lte',
  GT = 'gt',
  GTE = 'gte',
  IS_NULL = 'isnull',
  IN = 'in',
  RANGE = 'range',
  CONTAINS = 'icontains'
}
export enum ValueBooleanType {
  TRUE = 'True',
  FALSE = 'False'
}

export enum FieldType {
  SELECT = 'Select',
  INPUT = 'Input',
  DATE_TIME = 'DateTime',
  NUMBER = 'Number',
  LINK = 'Link',
  DATE = 'Date',
  RADIO = 'Radio'
}

export interface FieldsProps {
  fields: ViewsFieldsProps[]
}

export interface ViewsFieldsProps {
  filter_name?: string
  label: string
  name: string
  props?: Api
  type?: FieldType | string
}

interface Api {
  api?: string
  rule: null
}

const noEnumOperators = [
  FilterOperatorType.EQUAL,
  FilterOperatorType.LT,
  FilterOperatorType.LTE,
  FilterOperatorType.GT,
  FilterOperatorType.GTE,
  FilterOperatorType.IS_NULL,
  FilterOperatorType.RANGE
]

export const fieldTypeOperators = {
  [FieldType.SELECT]: [
    FilterOperatorType.EQUAL,
    FilterOperatorType.IN,
    FilterOperatorType.IS_NULL
  ],
  [FieldType.INPUT]: [
    FilterOperatorType.CONTAINS,
    FilterOperatorType.EQUAL,
    FilterOperatorType.IN,
    FilterOperatorType.IS_NULL
  ],
  [FieldType.DATE_TIME]: noEnumOperators,
  [FieldType.DATE]: noEnumOperators,
  [FieldType.NUMBER]: noEnumOperators,
  [FieldType.LINK]: [FilterOperatorType.EQUAL],
  [FieldType.RADIO]: [FilterOperatorType.IS_NULL]
}
